/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewTemplateDefinition } from '../models/new-template-definition';
import { TemplateDefinition } from '../models/template-definition';
import { TemplateDefinitionPartialExcludingProjectId } from '../models/template-definition-partial-excluding-project-id';
import { TemplateDefinitionRenderRequestDto } from '../models/template-definition-render-request-dto';
import { TemplateDefinitionRenderResponseDto } from '../models/template-definition-render-response-dto';
import { TemplateDefinitionWithRelations } from '../models/template-definition-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class TemplateDefinitionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation templateDefinitionControllerCount
   */
  static readonly TemplateDefinitionControllerCountPath = '/template-definitions/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerRender
   */
  static readonly TemplateDefinitionControllerRenderPath = '/template-definitions/render';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `render()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  render$Response(params?: {
    body?: TemplateDefinitionRenderRequestDto
  }): Observable<StrictHttpResponse<TemplateDefinitionRenderResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerRenderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateDefinitionRenderResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `render$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  render(params?: {
    body?: TemplateDefinitionRenderRequestDto
  }): Observable<TemplateDefinitionRenderResponseDto> {

    return this.render$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateDefinitionRenderResponseDto>) => r.body as TemplateDefinitionRenderResponseDto)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerFindById
   */
  static readonly TemplateDefinitionControllerFindByIdPath = '/template-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<TemplateDefinitionWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateDefinitionWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<TemplateDefinitionWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateDefinitionWithRelations>) => r.body as TemplateDefinitionWithRelations)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerDeleteById
   */
  static readonly TemplateDefinitionControllerDeleteByIdPath = '/template-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerUpdateById
   */
  static readonly TemplateDefinitionControllerUpdateByIdPath = '/template-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: TemplateDefinitionPartialExcludingProjectId
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: TemplateDefinitionPartialExcludingProjectId
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerFind
   */
  static readonly TemplateDefinitionControllerFindPath = '/template-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<TemplateDefinitionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TemplateDefinitionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<TemplateDefinitionWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TemplateDefinitionWithRelations>>) => r.body as Array<TemplateDefinitionWithRelations>)
    );
  }

  /**
   * Path part for operation templateDefinitionControllerCreate
   */
  static readonly TemplateDefinitionControllerCreatePath = '/template-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewTemplateDefinition
  }): Observable<StrictHttpResponse<TemplateDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, TemplateDefinitionControllerService.TemplateDefinitionControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TemplateDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewTemplateDefinition
  }): Observable<TemplateDefinition> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<TemplateDefinition>) => r.body as TemplateDefinition)
    );
  }

}
